import React, { useState } from 'react';

import Filters from 'components/filters';
import TeamMemberCard from 'components/teamMemberCard';

import { teamMembers, ALL_TRYBES_MEN } from './TrybesMenList.constants';
import { getUniqueTrybesMenCategories } from './TrybesMenList.helpers';
import { trybesMenList, teamMember } from './scss/TrybesMenList.module.scss';

const TrybesMenList = () => {
  const categories = getUniqueTrybesMenCategories(teamMembers);
  const [activeFilter, setActiveFilter] = useState(ALL_TRYBES_MEN);
  const filterList = () =>
    teamMembers.filter(({ team }) => team === activeFilter);
  const activeList =
    activeFilter === ALL_TRYBES_MEN ? teamMembers : filterList();

  return (
    <section>
      <Filters options={categories} onSelect={setActiveFilter} />
      <section className={trybesMenList}>
        {activeList.map(member => (
          <TeamMemberCard
            key={member.name}
            {...member}
            className={teamMember}
          />
        ))}
      </section>
    </section>
  );
};

export default TrybesMenList;
